// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__jh9qh","flow":"styles_flow__ccn-l"};